import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Carousel, Button, ConfigProvider } from 'antd'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import { set } from 'nprogress'
import index from 'src/pages/appTimeline'
import NewFooter from 'src/components/android-step/newFooter'
import { styled } from '@mui/material'

const ScrollDiv = styled('div')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

function One(data) {
  const { t } = useTranslation('commonAndroid')

  const step = [
    {
      phone: [
        {
          title: t(
            "<div style='line-height: 20px;'>On the<p style='font-weight: 600;display: inline-block;margin:0 3px;'>home screen, swipe up</p>to open the menu and tap on the<p style='font-weight: 600;display: inline-block;margin:0 3px;'>three dots</p>in the top right corner<p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin-left:3px;'>Settings</p>.</div>"
          ),
          img: [
            {
              src: '/images/android/six/1.png'
            },
            {
              src: '/images/android/six/1.1.png'
            }
          ]
        },
        {
          title: t(
            "<div style='line-height: 20px;'>Find and tap<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Hide apps</p>.</div>"
          ),
          img: [
            {
              src: '/images/android/six/2.png'
            }
          ]
        },
        {
          title: t(
            "<div style='line-height: 20px;'>Find and select<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Update service</p>and hit<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Done</p>.</div>"
          ),
          img: [
            {
              src: '/images/android/six/3.png'
            }
          ]
        }
      ]
    },
    {
      phone: [
        {
          title: t("<div style='line-height: 20px;'>Navigate to the app drawer on your Pixel device.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t("<div style='line-height: 20px;'>Press and hold the application you wish to hide.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t("<div style='line-height: 20px;'>From the pop-up menu, tap on the info icon.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t("<div style='line-height: 20px;'>Hit the Disable application option.</div>"),
          img: [
            {
              src: ''
            }
          ]
        }
      ]
    },
    {
      phone: [
        {
          title: t("<div style='line-height: 20px;'>Turn on the Motorola screen and unlock the device.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(
            "<div style='line-height: 20px;'>From the home screen, tap and hold an application you wish to hide or remove.</div>"
          ),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(
            "<div style='line-height: 20px;'>Drag the application on the Remove section at the top of the interface to hide the application from the home screen.</div>"
          ),
          img: [
            {
              src: ''
            }
          ]
        }
      ]
    },
    {
      phone: [
        {
          title: t("<div style='line-height: 20px;'>Open Xiaomi device settings.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>Tap "App lock".</div>`),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>Then tap "Hidden apps."</div>`),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(
            `<div style='line-height: 20px;'>Tap "Manage hidden apps" and select the apps you wish to hide.</div>`
          ),
          img: [
            {
              src: ''
            }
          ]
        }
      ]
    },
    {
      phone: [
        {
          title: t("<div style='line-height: 20px;'>Launch the app drawer.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>Use the swipe gesture to open the Hidden Space.</div>`),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>Hit the + menu on the top-right side.</div>`),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>Choose the apps you wish to hide.</div>`),
          img: [
            {
              src: ''
            }
          ]
        }
      ]
    },
    {
      phone: [
        {
          title: t("<div style='line-height: 20px;'>Head over to Settings.</div>"),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>Click on the "Display tab" and select "Home screen."</div>`),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(`<div style='line-height: 20px;'>There is an option named "Hide apps."</div>`),
          img: [
            {
              src: ''
            }
          ]
        },
        {
          title: t(
            `<div style='line-height: 20px;'>Select the applications you wish to hide and then click Done.</div>`
          ),
          img: [
            {
              src: ''
            }
          ]
        }
      ]
    }
  ]

  const phone = [
    {
      name: 'Samsung'
    },
    {
      name: 'Pixel'
    },
    {
      name: 'Motorola'
    },
    {
      name: 'XiaoMi'
    },
    {
      name: 'OnePlus'
    },
    {
      name: 'LG'
    }
  ]

  //  const newsetp=

  const imgToggle = useRef()

  //说明处的步骤索引
  const [currentSlide, setcurrentSlide] = useState(0)

  //当前选择的手机类型
  const [phoneNum, setPhoneNum] = useState(0)

  const [carousel, setCarousel] = useState(step[0].phone[0].img)

  const [autoplay, setAutoplay] = useState(true)

  const [specificIndex, setSpecificIndex] = useState(currentSlide) // 你想访问的图片索引

  //点击步骤切换步骤和显示对应的图片
  const Handler = index => {
    setCarousel(step[index].phone[index].img)
    setcurrentSlide(index)
    setImg(0)
    imgToggle.current.goTo(0)
  }

  const { query } = useRouter()

  const [a, setA] = useState(1)

  useEffect(() => {
    const intervalDuration = currentSlide !== 0 ? 3000 : 6000

    const interval = setInterval(() => {
      if (autoplay) {
        const nextSlide = (currentSlide + 1) % step[0].phone.length
        setCarousel(step[0].phone[nextSlide].img)
        setcurrentSlide(nextSlide)
        setImg(0)
        imgToggle.current.goTo(0)
      }
    }, intervalDuration)

    return () => clearInterval(interval)
  }, [currentSlide, autoplay])

  const [Img, setImg] = useState(0)

  //选择手机类型
  const handelPhone = i => {
    setPhoneNum(i)
    setcurrentSlide(0)
    setCarousel(step[i].phone.flatMap(item => item.img))
  }

  useEffect(() => {
    let startX

    const handleTouchStart = e => {
      // 记录触摸起始位置
      startX = e.touches[0].clientX
    }

    const handleTouchMove = e => {
      // 计算触摸移动距离
      e.preventDefault()

      const currentX = e.touches[0].clientX
      const deltaX = currentX - startX

      // 根据 deltaX 判断左右滑动
      // 根据 deltaX 判断左右滑动
      if (deltaX > 0) {
        if (parseInt(currentSlide) === 0) {
          if (parseInt(Img) === 0 && parseInt(Img + 1) !== carousel.length) {
            setCarousel(step[0].phone[2].img) // 修改为访问第一种结构
            setcurrentSlide(2)
            setImg(0)
            imgToggle.current.goTo(0)
          } else {
            setImg(0)
          }
        } else {
          setCarousel(step[0].phone[currentSlide - 1].img) // 修改为访问第一种结构
          setcurrentSlide(currentSlide - 1)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      } else if (deltaX < 0) {
        if (parseInt(currentSlide) === 0) {
          if (parseInt(Img) + 1 === carousel.length) {
            setCarousel(step[0].phone[1].img) // 修改为访问第一种结构
            setcurrentSlide(1)
            setImg(0)
          }
        } else if (parseInt(currentSlide) === 2) {
          setcurrentSlide(0)
          setCarousel(step[0].phone[0].img) // 修改为访问第一种结构
          setImg(0)
          imgToggle.current.goTo(0)
        } else {
          setcurrentSlide(currentSlide + 1)
          setCarousel(step[0].phone[currentSlide + 1].img) // 修改为访问第一种结构
          setImg(0)
          imgToggle.current.goTo(0)
        }
      }
    }

    // 添加事件监听器
    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('touchmove', handleTouchMove)

    // 清理工作
    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [currentSlide, carousel, query, a, Img])

  return (

    <Fragment>

      {/* 旧布局 */}
      {/* <div
        className={`w-[620px] Ssm:w-[100%] mx-auto justify-between setup ${data.fullScreen ? 'flex flex-col' : ' Smd:flex'
          }`}
      >
        {data.fullScreen && (
          <Icon
            onClick={() => {
              data.setFullScreen(false)
            }}
            icon='maki:cross'
            className={` absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
          />
        )}

        <div
          onMouseEnter={() => {
            setAutoplay(false), setA(0)
          }}
          onMouseLeave={() => {
            setAutoplay(true), setA(1)
          }}
          className={`w-full text-black Ssm:w-[100%] mx-auto justify-between items-center setup ${data.fullScreen ? 'flex flex-col mx-auto' : ' Smd:flex Dsm:mt-[80px] Dsm:xs:mt-[30px]'
            }`}
        >
          <div
            className={`w-[343px] h-[506px] ${data.fullScreen ? 'order-2 w-[80%] mx-auto' : 'Dsm:w-[100%] Ssm:mx-auto'}`}
          >
            <p
              className={`text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] Ssm:text-center  ${data.fullScreen ? 'hidden' : ''
                }`}
            >
              {t('Hide Msafely')}
            </p>
            <div className={`w-full ${data.fullScreen ? 'pt-[20px]' : 'Dsm:pt-[5px] pt-[5px]'}`}>
              设备类型：
              <div className={`grid grid-cols-3 place-items-center w-full ${data.fullScreen ? 'gap-2' : 'gap-4'}`}>
                {phone.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => handelPhone(index)}
                    className={`w-[94px] h-[40px] text-[12px] rounded-[6px] hover:text-[#00EEC3] ${phoneNum === index
                      ? 'text-[#00EEC3] bg-[#FFF]'
                      : ' text-[#9A9A9F] bg-[#F8F8F8] border-[1px] border-[#E5E7EB]'
                      }`}
                    style={{ boxShadow: phoneNum === index ? '0px 0px 3px 0px #00000033' : 'none' }}
                  >
                    {item.name}
                  </button>
                ))}
              </div>

              手机对应型号操作说明：
              <div className='mt-[40px]'>
                {step[phoneNum].phone.map((item, index) => (
                  <div
                    onClick={() => Handler(index)}
                    key={index}
                    className={`flex text-[14px] cursor-pointer ${data.fullScreen ? 'mt-[10px]' : 'mt-[7px] Dsm:mt-[10px]'
                      }`}
                  >
                    <div className='flex'>
                      <p
                        className={`w-[24px] h-[22px] rounded-full flex items-center justify-center ${currentSlide === index && 'bg-[#12D8AB] text-white'
                          }`}
                      >
                        {index + 1}.
                      </p>
                      <div
                        className={`ml-1 w-[100%] ${data.fullScreen ? 'text-[13px]' : 'text-[13px]'}`}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={`w-[220px] rounded-[24px] p-[6px] h-[506px] border-[1px] border-[#ACB1BD] relative ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
              }`}
          >
            <Carousel
              autoplay={autoplay}
              className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
              ref={imgToggle}
              cancelable={false}
              swipeToSlide={true} // 允许滑动切换
            >
              当选择机型并非第一种时不显示操作步骤图片
              {phoneNum === 0 && (
                <>
                  {carousel.map((item, index) => {
                    return (
                      <div key={index} className=' rounded-[15px]'>
                        <Image
                          alt=''
                          width={100}
                          height={100}
                          src={item.src}
                          className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                        />
                      </div>
                    )
                  })}
                </>
              )}
            </Carousel>

            <div className='flex items-center justify-center mt-5'>
              {step[phoneNum].phone.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setCarousel(step[index].phone[index].img), setcurrentSlide(index), imgToggle.current.goTo(0)
                  }}
                  className={`border-[1px] ${index !== 0 && 'ml-2'
                    } border-[#12D8AB] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${currentSlide === index && 'bg-[#12D8AB]'
                    } `}
                ></div>
              ))}
            </div>
            <div className='absolute -left-[3px] top-[55px]'>
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='' />
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='' />
            </div>
          </div>
        </div>

        <div className={`Smd:hidden ${data.fullScreen && 'hidden'}`} onClick={() => data.setFullScreen(true)}>
          <Image
            src='/images/android/watch.png'
            width={100}
            height={100}
            alt=''
            className='mx-auto w-[150px] mt-[20px]'
          />
        </div>
      </div> */}

      <ScrollDiv
        className={`w-[620px] Ssm:w-[100%] mx-auto justify-between setup ${data.fullScreen ? 'flex flex-col' : ' Smd:flex'} overflow-auto pb-[88px] h-full p-[12px_15px_15px_15px] max-w-[1440px]`}
      >
        {data.fullScreen && (
          <Icon
            onClick={() => {
              data.setFullScreen(false)
            }}
            icon='maki:cross'
            className={` absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
          />
        )}

        <div
          onMouseEnter={() => {
            setAutoplay(false), setA(0)
          }}
          onMouseLeave={() => {
            setAutoplay(true), setA(1)
          }}
          className={`w-full text-black Ssm:w-[100%] mx-auto justify-between items-start setup ${data.fullScreen ? 'flex flex-col mx-auto' : ' Smd:flex Dsm:mt-[80px] Dsm:xs:mt-[30px]'
            }`}
        >
          <div
            className={`w-[343px] h-auto ${data.fullScreen ? 'order-2 w-[80%] mx-auto' : 'Dsm:w-[100%] Ssm:mx-auto'}`}
          >
            <p
              className={`text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] Ssm:text-center  ${data.fullScreen ? 'hidden' : ''
                }`}
            >
              {t('Hide Msafely')}
            </p>
            <div className={`w-full ${data.fullScreen ? 'pt-[20px]' : 'Dsm:pt-[5px] pt-[5px]'}`}>
              {/* 设备类型： */}
              <div className={`grid grid-cols-3 place-items-center w-full ${data.fullScreen ? 'gap-2' : 'gap-4'}`}>
                {phone.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => handelPhone(index)}
                    className={`w-[94px] h-[40px] text-[12px] rounded-[6px] hover:text-[#454CFF] ${phoneNum === index
                      ? 'text-[#454CFF] bg-[#FFF]'
                      : ' text-[#9A9A9F] bg-[#F8F8F8] border-[1px] border-[#E5E7EB]'
                      }`}
                    style={{ boxShadow: phoneNum === index ? '0px 0px 3px 0px #00000033' : 'none' }}
                  >
                    {item.name}
                  </button>
                ))}
              </div>

              {/* 手机对应型号操作说明： */}
              <div className='mt-[40px]'>
                {step[phoneNum].phone.map((item, index) => (
                  <div
                    onClick={() => Handler(index)}
                    key={index}
                    className={`flex text-[14px] cursor-pointer ${data.fullScreen ? 'mt-[10px]' : 'mt-[7px] Dsm:mt-[10px]'
                      }`}
                  >
                    <div className='flex'>
                      <p
                        className={`w-[24px] h-[22px] rounded-full flex items-center justify-center ${currentSlide === index && 'bg-[#2A99FF] text-white'
                          }`}
                      >
                        {index + 1}.
                      </p>
                      <div
                        className={`ml-1 w-[100%] ${data.fullScreen ? 'text-[13px]' : 'text-[13px]'}`}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={`w-[220px] rounded-[24px] p-[6px] h-[506px] border-[1px] border-[#ACB1BD] relative ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
              }`}
          >
            <Carousel
              autoplay={autoplay}
              className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
              ref={imgToggle}
              cancelable={false}
              swipeToSlide={true} // 允许滑动切换
            >
              {/* 当选择机型并非第一种时不显示操作步骤图片 */}
              {phoneNum === 0 && (
                <>
                  {carousel.map((item, index) => {
                    return (
                      <div key={index} className=' rounded-[15px]'>
                        <Image
                          alt='img'
                          width={100}
                          height={100}
                          src={item.src}
                          className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                        />
                      </div>
                    )
                  })}
                </>
              )}
            </Carousel>

            <div className='flex items-center justify-center mt-5'>
              {step[phoneNum].phone.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setCarousel(step[index].phone[index].img), setcurrentSlide(index), imgToggle.current.goTo(0)
                  }}
                  className={`border-[1px] ${index !== 0 && 'ml-2'
                    } border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${currentSlide === index && 'bg-[#2A99FF]'
                    } `}
                ></div>
              ))}
            </div>
            <div className='absolute -left-[3px] top-[55px]'>
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-center Smd:hidden ${data.fullScreen && 'hidden'}`} onClick={() => data.setFullScreen(true)}>
          <Image
            src='/images/bind/watch.svg'
            width={100}
            height={100}
            alt='watch'
            className='mx-auto w-[58px] mt-[36px]'
          />
          <p className='mt-[14px] text-[14px] text-[#454CFF] font-[600]'>{t('Watch a tutorial')}</p>
        </div>

      </ScrollDiv>

      <NewFooter nowPage={data.nowPage} setNowPage={data.setNowPage} startMonitoring={data.startMonitoring} />
    </Fragment>
  )
}

export default One
